import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePagecopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePagecopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetMainPageSummary: any[];
  GetMainPageSummary_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
}

export class HomePagecopy_ScreenBase extends React.PureComponent<
  IHomePagecopy_ScreenProps,
  any
> {
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "c7227ac6-5b58-42f1-bb9f-953a93fd1373",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 85056, PropertyName: "label", Value: "Profil" },
        { Id: 839916, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 35731, PropertyName: "value", Value: "Merhaba," },
        { Id: 544028, PropertyName: "value", Value: "Döviz Kuru" },
        { Id: 675742, PropertyName: "value", Value: "Kasa Hesapları Tutarı" },
        { Id: 240176, PropertyName: "value", Value: "Kasa Hesapları" },
        { Id: 629271, PropertyName: "value", Value: "Müşteri Alacak Tutarı" },
        { Id: 330653, PropertyName: "value", Value: "Cari Hesapları" },
        { Id: 324908, PropertyName: "value", Value: "Tedarikçi Borç Tutarı" },
        { Id: 684319, PropertyName: "value", Value: "Tedarikçi Hesapları" },
        { Id: 731566, PropertyName: "value", Value: "Banka Hesapları Tutarı" },
        { Id: 141714, PropertyName: "value", Value: "Banka Hesapları" },
        { Id: 298501, PropertyName: "value", Value: "Envanter Durumu" },
        { Id: 859968, PropertyName: "value", Value: "Adet" },
        { Id: 311903, PropertyName: "value", Value: "Metrekare" },
        { Id: 863449, PropertyName: "value", Value: "Fiyat TL" },
        { Id: 218103, PropertyName: "value", Value: "Fiyat Dolar" },
        { Id: 188650, PropertyName: "value", Value: "Borç Çek Senetleri" },
        { Id: 931617, PropertyName: "value", Value: "Borç Çeki TL" },
        { Id: 64907, PropertyName: "value", Value: "Borç Çeki Dolar" },
        { Id: 261499, PropertyName: "value", Value: "Borç Seneti TL" },
        { Id: 717791, PropertyName: "value", Value: "Borç Seneti Dolar" },
        { Id: 179016, PropertyName: "value", Value: "Alacak Çek Senetleri" },
        { Id: 539896, PropertyName: "value", Value: "Alacak Çek TL" },
        { Id: 446837, PropertyName: "value", Value: "Alacak Çek Dolar" },
        { Id: 60440, PropertyName: "value", Value: "Alacak Senet TL" },
        { Id: 927628, PropertyName: "value", Value: "Alacak Senet Dolar" },
        { Id: 584282, PropertyName: "value", Value: "Hızlı Erişim" },
        { Id: 274413, PropertyName: "value", Value: "Alış Faturları" },
        { Id: 168442, PropertyName: "value", Value: "Satış Faturaları" },
        { Id: 613128, PropertyName: "value", Value: "Masraf Faturaları" },
        { Id: 548078, PropertyName: "value", Value: "Kasa" },
        { Id: 859146, PropertyName: "value", Value: "Banka" },
        { Id: 573260, PropertyName: "value", Value: "Müşteri Hesapları" },
        { Id: 365163, PropertyName: "value", Value: "Tedarikçi Hesapları" },
        { Id: 790563, PropertyName: "value", Value: "Ürün Satış Analizi" },
        { Id: 36025, PropertyName: "value", Value: "Mağaza Ciro Analizi" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetMainPageSummary: [],
      ListUser: [],
      GetImage: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagecopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagecopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagecopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      kUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePagecopy/HomePagecopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMainPageSummary = result?.data.getMainPageSummary;
    formVars.homepagecopy_733986_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].dovizKuru
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].dovizKuru
        : null
    );
    formVars.homepagecopy_703948_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalance
        : null
    );
    formVars.homepagecopy_733498_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalanceU
        : null
    );
    formVars.homepagecopy_860413_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalance
        : null
    );
    formVars.homepagecopy_664454_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalanceU
        : null
    );
    formVars.homepagecopy_808789_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalance
        : null
    );
    formVars.homepagecopy_170281_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalanceU
        : null
    );
    formVars.homepagecopy_192637_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalance
        : null
    );
    formVars.homepagecopy_923084_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalanceU
        : null
    );
    formVars.homepagecopy_319848_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanter1
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanter1
        : null
    );
    formVars.homepagecopy_182548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanter2
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanter2
        : null
    );
    formVars.homepagecopy_189134_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanterTutar
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanterTutar
        : null
    );
    formVars.homepagecopy_655450_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanterTutar2
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanterTutar2
        : null
    );
    formVars.homepagecopy_104520_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitCheques
        : null
    );
    formVars.homepagecopy_917594_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitChequesU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitChequesU
        : null
    );
    formVars.homepagecopy_687003_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNote
        : null
    );
    formVars.homepagecopy_756936_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNoteU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNoteU
        : null
    );
    formVars.homepagecopy_614624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditCheques
        : null
    );
    formVars.homepagecopy_304472_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditChequesU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditChequesU
        : null
    );
    formVars.homepagecopy_196493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNote
        : null
    );
    formVars.homepagecopy_792682_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNoteU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNoteU
        : null
    );
    stateVars.ListUser = result?.data.listUser;
    formVars.homepagecopy_2679_value = ReactSystemFunctions.toString(
      this,
      stateVars.ListUser !== undefined
        ? stateVars.ListUser?.length > 0
          ? stateVars.ListUser[0].firstName
          : null
        : this.state.ListUser?.length > 0
        ? this.state.ListUser[0].firstName
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.homepagecopy_561147_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepagecopy_561147_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.homepagecopy_2679_value = ReactSystemFunctions.toString(
      this,
      stateVars.ListUser !== undefined
        ? stateVars.ListUser?.length > 0
          ? stateVars.ListUser[0].firstName
          : null
        : this.state.ListUser?.length > 0
        ? this.state.ListUser[0].firstName
        : null
    );

    formVars.homepagecopy_733986_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].dovizKuru
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].dovizKuru
        : null
    );

    formVars.homepagecopy_703948_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalance
        : null
    );

    formVars.homepagecopy_733498_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].cashBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].cashBalanceU
        : null
    );

    formVars.homepagecopy_860413_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalance
        : null
    );

    formVars.homepagecopy_664454_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].customerBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].customerBalanceU
        : null
    );

    formVars.homepagecopy_808789_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalance
        : null
    );

    formVars.homepagecopy_170281_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].vendorBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].vendorBalanceU
        : null
    );

    formVars.homepagecopy_192637_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalance
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalance
        : null
    );

    formVars.homepagecopy_923084_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].bankBalanceU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].bankBalanceU
        : null
    );

    formVars.homepagecopy_319848_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanter1
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanter1
        : null
    );

    formVars.homepagecopy_182548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanter2
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanter2
        : null
    );

    formVars.homepagecopy_189134_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanterTutar
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanterTutar
        : null
    );

    formVars.homepagecopy_655450_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].envanterTutar2
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].envanterTutar2
        : null
    );

    formVars.homepagecopy_104520_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitCheques
        : null
    );

    formVars.homepagecopy_917594_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitChequesU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitChequesU
        : null
    );

    formVars.homepagecopy_687003_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNote
        : null
    );

    formVars.homepagecopy_756936_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].debitNoteU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].debitNoteU
        : null
    );

    formVars.homepagecopy_614624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditCheques
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditCheques
        : null
    );

    formVars.homepagecopy_304472_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditChequesU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditChequesU
        : null
    );

    formVars.homepagecopy_196493_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNote
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNote
        : null
    );

    formVars.homepagecopy_792682_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetMainPageSummary !== undefined
        ? stateVars.GetMainPageSummary?.length > 0
          ? stateVars.GetMainPageSummary[0].creditNoteU
          : null
        : this.state.GetMainPageSummary?.length > 0
        ? this.state.GetMainPageSummary[0].creditNoteU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePagecopyComponent_557324_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "596436",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_85056_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_839916_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_261980_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "AlisFatura",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_752361_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "SatisFatura",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_495004_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "MasrafList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_573818_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "KasaList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_698571_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "BankaList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_521445_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "MusteriList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_632894_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "TedarikciList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_698701_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "UrunSatisAnaliz",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePagecopyComponent_303852_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePagecopy",
      "MagazaCiroAnalizi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [596436, , , , , , , , , ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagecopyPageInit();
    }
  }
}
